import { render, staticRenderFns } from "./ReplyChatBox.vue?vue&type=template&id=65994512&scoped=true"
import script from "./ReplyChatBox.vue?vue&type=script&lang=js"
export * from "./ReplyChatBox.vue?vue&type=script&lang=js"
import style0 from "./ReplyChatBox.vue?vue&type=style&index=0&id=65994512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65994512",
  null
  
)

export default component.exports